<template>
    <v-card>
        <v-layout
            class="headline px-4 py-3 font-weight-medium"
            style="color: #fff; background-color: #5cb860;"
            row
            align-center
        >
            <v-icon dark class="mr-2">mdi-account-edit</v-icon>
            Edit Student
        </v-layout>

        <v-card-text class="px-4 pt-4 pb-2">
            <div
                class="subheading font-weight-medium mb-1"
                style="color: #5cb860;"
            >
                {{ student.fullName }}
            </div>
            <div class="caption grey--text mb-4">ID: {{ student.studentID }}</div>

            <v-divider class="mb-4"></v-divider>

            <v-form ref="form" lazy-validation>
                <div class="caption font-weight-medium grey--text text--darken-1 mb-1 text-uppercase">English Name</div>
                <v-layout row wrap class="mb-2">
                    <v-flex xs12 sm6 class="pr-3">
                        <v-text-field
                            label="First Name (English)"
                            v-model="form.fnameE"
                            maxlength="50"
                            color="success"
                            outline
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            label="Last Name (English)"
                            v-model="form.lnameE"
                            maxlength="50"
                            color="success"
                            outline
                        ></v-text-field>
                    </v-flex>
                </v-layout>

                <div class="caption font-weight-medium grey--text text--darken-1 mb-1 text-uppercase">Contact</div>
                <v-layout row wrap class="mb-2">
                    <v-flex xs12 sm6 class="pr-3">
                        <v-text-field
                            label="Father"
                            v-model="form.father"
                            maxlength="100"
                            color="success"
                            outline
                            prepend-inner-icon="mdi-account"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            label="Phone"
                            v-model="form.phone"
                            maxlength="100"
                            color="success"
                            outline
                            prepend-inner-icon="mdi-phone"
                        ></v-text-field>
                    </v-flex>
                </v-layout>

                <div class="caption font-weight-medium grey--text text--darken-1 mb-1 text-uppercase">Address</div>
                <v-layout row wrap>
                    <v-flex xs12 class="mb-0">
                        <v-text-field
                            label="Street Address"
                            v-model="form.address"
                            maxlength="100"
                            color="success"
                            outline
                            prepend-inner-icon="mdi-map-marker"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm5 class="pr-3">
                        <v-text-field
                            label="City"
                            v-model="form.city"
                            maxlength="50"
                            color="success"
                            outline
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 class="pr-3">
                        <v-text-field
                            label="State"
                            v-model="form.state"
                            maxlength="10"
                            color="success"
                            outline
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <v-text-field
                            label="Zip Code"
                            v-model="form.zipCode"
                            maxlength="15"
                            color="success"
                            outline
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>

            <v-alert
                :value="!!errorMessage"
                type="error"
                class="mt-1 mb-0"
            >
                {{ errorMessage }}
            </v-alert>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
            <v-spacer></v-spacer>
            <v-btn flat @click="closeDialog()">Cancel</v-btn>
            <v-btn color="success" :loading="processing" @click="save()">
                <v-icon left>mdi-content-save</v-icon>
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        student: Object,
        reloadGrid: Function,
        closeUpdateStudentDialog: Function,
        getDomain: Function,
    },
    data() {
        return {
            processing: false,
            errorMessage: "",
            form: {
                fnameE: "",
                lnameE: "",
                father: "",
                address: "",
                phone: "",
                city: "",
                state: "",
                zipCode: "",
            },
        };
    },
    watch: {
        student: {
            immediate: true,
            handler(val) {
                if (!val) return;
                const parts = (val.fullNameE || "").split(",");
                this.form = {
                    lnameE: (parts[0] || val.lnameE || "").trim(),
                    fnameE: (parts[1] || val.fnameE || "").trim(),
                    father: val.father || "",
                    address: val.address || "",
                    phone: val.phone || "",
                    city: val.city || "",
                    state: val.state || "",
                    zipCode: val.zipCode || "",
                };
                this.errorMessage = "";
            },
        },
    },
    methods: {
        closeDialog() {
            this.$refs.form && this.$refs.form.reset();
            this.errorMessage = "";
            this.closeUpdateStudentDialog();
        },
        async save() {
            if (!this.$refs.form.validate()) return;

            this.processing = true;
            this.errorMessage = "";

            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/UpdateStudentDetails",
                    {
                        studentID: this.student.studentID,
                        fnameE: this.form.fnameE,
                        lnameE: this.form.lnameE,
                        father: this.form.father,
                        address: this.form.address,
                        phone: this.form.phone,
                        city: this.form.city,
                        state: this.form.state,
                        zipCode: this.form.zipCode,
                    },
                );

                this.$notify({
                    text: "Student updated successfully",
                    group: "notification",
                    type: "success",
                });

                this.closeDialog();
                this.reloadGrid();
            } catch (e) {
                this.errorMessage = "Failed to update student. Please try again.";
            } finally {
                this.processing = false;
            }
        },
    },
};
</script>
